import { StepExperiment } from '#src/app/pages/startAPetitionV2/shared/components';

import { ChatAppEntry } from './components/ChatAppEntry';
import { Create } from './components/Create';
import { Edit } from './components/Edit';
import { Edit as EditAiTextLabeling } from './components/EditAiTextLabeling';
import { Edit as EditWithDecisionMakers } from './components/EditWithDecisionMakers';
import { Intro } from './components/Intro';
import { Intro as IntroMelones } from './components/IntroMelones';
import { IssuePrompt } from './components/IssuePrompt';
import { Location } from './components/Location';
import { Media } from './components/Media';
import { OptionalPreview } from './components/OptionalPreview';
import { PersonalPrompt } from './components/PersonalPrompt';
import { PersonalPrompt as PersonalPromptAiTextLabeling } from './components/PersonalPromptAiTextLabeling';
import { PrePublish } from './components/PrePublish';
import { Preview } from './components/Preview';
import { Preview as PreviewWithDecisionMakers } from './components/PreviewWithDecisionMakers';
import { SocialEntry } from './components/SocialEntry';
import { usePageBody } from './hooks/usePageBody';

export function PageBody() {
	const { data, actions } = usePageBody();

	// oxlint-disable-next-line complexity
	const Component = (() => {
		switch (true) {
			case actions.matches('intro') && data.shouldShowMelonesCampaign:
				return <IntroMelones />;
			case actions.matches('intro'):
				return <Intro />;
			case actions.matches('issue'):
				return <IssuePrompt />;
			case actions.matches('personal-story'):
				return (
					<StepExperiment
						experiment="sapAiTextLabeling"
						control={PersonalPrompt}
						variants={{ enabled: PersonalPromptAiTextLabeling }}
					/>
				);
			case actions.matches('chat-app-entry'):
				return <ChatAppEntry />;
			case actions.matches('social'):
				return <SocialEntry />;
			case actions.matches('optional-preview'):
				return <OptionalPreview />;
			// edit's gate, so a starter who saw decision makers on edit sees them on preview too
			case actions.matches('preview') && !data.shouldShowAiTextLabeling && data.shouldShowDecisionMakers:
				return (
					<StepExperiment
						experiment="sapDecisionMakerExperiment"
						control={Preview}
						variants={{ variant: PreviewWithDecisionMakers }}
					/>
				);
			case actions.matches('preview'):
				return <Preview />;
			case actions.matches('create'):
				return <Create />;
			// one step experiment owns edit per user: AI text labeling (EU markets) whenever it runs, in every
			// group; otherwise the decision maker experiment (en-US), counting only drafts eligible for inference.
			// Eligibility is settled before edit (personal story waits for location inference), so this can't
			// switch while the starter is on the step and remount it
			case actions.matches('edit') && data.shouldShowAiTextLabeling:
				return (
					<StepExperiment experiment="sapAiTextLabeling" control={Edit} variants={{ enabled: EditAiTextLabeling }} />
				);
			case actions.matches('edit') && data.shouldShowDecisionMakers:
				return (
					<StepExperiment
						experiment="sapDecisionMakerExperiment"
						control={Edit}
						variants={{ variant: EditWithDecisionMakers }}
					/>
				);
			case actions.matches('edit'):
				return <Edit />;
			case actions.matches('location'):
				return <Location />;
			case actions.matches('media'):
				return <Media />;
			case actions.matches('prepublish'):
				return <PrePublish />;
			default:
				// probably throw an error here and handle in error boundary?
				return <div>unknown state</div>;
		}
	})();

	return Component;
}
